import React from 'react';
import {
    Tooltip as MaterialTooltip,
    TooltipProps as MaterialTooltipProps,
    tooltipClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';

const StyledMaterialTooltip = styled(({ className, ...props }: any) => (
    <MaterialTooltip {...props} classes={{ popper: className }} />
))`
    & .${tooltipClasses.tooltip} {
        background-color: #eff3f8;
        color: rgba(0, 0, 0, 0.87);
        font-size: 12px;
        border-radius: 100px;

        &.tooltipDark {
            background: #252525;
            box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.5);
            font-size: 16px;
            font-weight: 600;
            color: #fff;
            padding: 0.25rem 1rem;
        }
        &.tooltipSmall {
            font-size: 10px;
        }
    }
`;

export interface TooltipProps extends MaterialTooltipProps {
    theme?: 'dark' | 'light';
    size?: 'small' | 'medium';
}

const Tooltip: React.FC<TooltipProps> = ({
    className,
    theme = 'dark',
    size = 'small',
    title,
    children,
    ...props
}) => {
    return (
        <StyledMaterialTooltip
            title={title}
            {...props}
            slotProps={{
                tooltip: {
                    className: classNames(
                        { tooltipDark: theme === 'dark' },
                        { tooltipSmall: size === 'small' },
                        className,
                    ),
                },
            }}
        >
            {children}
        </StyledMaterialTooltip>
    );
};

export default Tooltip;
